import { ECookiesActionTypes, TCookiesAccepted } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const cookiesAccepted: () => TCookiesAccepted = actionGenerator<ECookiesActionTypes.CookiesAccepted>(
  ECookiesActionTypes.CookiesAccepted,
);
